;(() => {
  const angular = window.angular;

  angular
    .module('app')
    .config(ReportRouter);

  ReportRouter.$inject = ['$stateProvider'];

  function ReportRouter ($stateProvider) {
    $stateProvider
      // Power BI Reports
      .state('member.project.reports', {
        url: '/reports',
        redirectTo: 'member.project.reports.embedded',
        template: '<ui-view></ui-view>',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Reportes'
        }
      })
      .state('member.project.reports.embedded', {
        url: '/embedded/:reportId',
        component: 'embeddedReports',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Embedded'
        },
        resolve: {
          hasTool: ['tools', 'AppUtils', function (tools, utils) {
            const hasTool = tools.find(tool => tool.module === 'xompassEmbeddedReports');
            if (!hasTool) {
              throw utils.getHTTPError(new Error('Not allowed'), {
                redirectTo: 'member.invalidTool',
                params: { tool: 'xompassEmbeddedReport' }
              });
            }
          }],
          reports: ['Customer', 'Manager', '$transition$', function (Customer, Manager, $transition$) {
            let params = $transition$.params();
            let user = Manager.getCachedCurrent();
            return Customer
              .prototype$__get__projects__embeddedReports({
                id: user.customerId,
                nk: params.projectId,
                filter: { fields: ['id', 'name', 'source'] }
              })
              .$promise
              .then(reports => {
                let tree = [];
                reports.forEach(report => {
                  tree.push({
                    id: report.id,
                    text: report.name,
                    parent: '#'
                  });
                });
                return { tree: tree, reports: reports };
              });
          }]
        }
      });
  }

})();
